import { FC } from 'react';
import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import FormField, { IProps } from './FormField';

interface IOptions {
	label: string | number | React.ReactElement<any, string | React.JSXElementConstructor<any>>;
	value: unknown;
}

interface IFormFieldOptions extends Omit<IProps, 'children'> {
	options: IOptions[];
	value?: string | boolean;
	name: string;
	onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
	onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
}

const FormFieldOptions: FC<IFormFieldOptions> = ({
	error,
	helperText,
	id,
	label,
	value,
	options,
	onChange,
	onBlur,
	name,
	topLabel,
}) => {
	return (
		<FormField error={error} helperText={helperText} id={id} label={label} topLabel={topLabel}>
			<RadioGroup sx={{ display: 'flex', gap: 2 }} name={name} value={value} onChange={onChange} onBlur={onBlur}>
				{options.map((option) => (
					<FormControlLabel
						key={option.value as string}
						sx={{ textAlign: 'left' }}
						control={
							<Radio
								icon={<CircleOutlinedIcon color={error ? 'error' : undefined} />}
								checkedIcon={<CheckCircleIcon />}
								value={option.value}
								sx={{
									'& .MuiSvgIcon-root': { fontSize: '4rem' },
								}}
							/>
						}
						label={option.label}
					/>
				))}
			</RadioGroup>
		</FormField>
	);
};

export default FormFieldOptions;
